import React from 'react'
import './scss/styles.scss'
import Link from 'gatsby-link'

const page = '...'

class Page extends React.Component {
  t = (msg, params) => this.props.intl.formatMessage(msg, params);

  render() {
    const { lang = 'en', content } = this.props
    return (
      <div>
        <div className="main">
          {content}
        </div>
      </div>
    )
  }
}

export default (Page);
